import { jsx as i } from "react/jsx-runtime";
import c from "react";
import { c as d } from "./index.CWkFp9WS.js";
import { S as m } from "./index.J3BKoY__.js";
import '../assets/ODSGlobalHeaderMainLink.css';const b = c.forwardRef((l, r) => {
  const { label: s, selected: a, asChild: e, className: o, children: n, ...t } = l;
  return /* @__PURE__ */ i(
    e ? m : "a",
    {
      ref: r,
      className: d("ODSGlobalHeaderMainLink", o, {
        "ODSGlobalHeaderMainLink--selected": a
      }),
      "aria-current": a ? "page" : !1,
      ...t,
      children: e ? n : s
    }
  );
});
b.displayName = "ODSGlobalHeaderMainLink";
const f = c.forwardRef((l, r) => {
  const { label: s, selected: a, asChild: e, className: o, children: n, ...t } = l;
  return /* @__PURE__ */ i(
    e ? m : "button",
    {
      ref: r,
      className: d("ODSGlobalHeaderMainLink", o, {
        "ODSGlobalHeaderMainLink--selected": a
      }),
      "aria-current": a ? "page" : !1,
      ...t,
      children: e ? n : s
    }
  );
});
f.displayName = "ODSGlobalHeaderMainButton";
export {
  b as O,
  f as a
};
//# sourceMappingURL=ODSGlobalHeaderMainLink.qgXBWDbZ.js.map
